module.exports = __webpack_public_path__ + "static/media/stampdbackground.76dc471f.svg";